<template>
  <div class="row">
    <div class="col-lg-7">
      <el-card>
        <el-form class="p-2" ref="form" :model="form" :rules="rules">
          <el-form-item label="旧密码" prop="old_password">
            <el-input type="password" v-model="form.old_password"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="password">
            <el-input type="password" v-model="form.password"></el-input>
          </el-form-item>
          <el-form-item label="重复新密码" prop="password_confirmation">
            <el-input type="password" v-model="form.password_confirmation"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button :loading="loading" type="primary" @click="reset">确认修改</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>

import Layout2 from '../../Shared/Layout2'
import axios from 'axios'

export default {
  layout: Layout2,

  data() {
    var validatePass = (rule, value, callback) => {
      if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === this.form.old_password) {
        callback(new Error('新旧密码不能相同!'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      rules: {
        password: [
          {required: true, message: '请输入新密码', trigger: 'blur'},
          {min: 6, max: 50, message: '长度在 6 到 50 个字符', trigger: 'blur'},
          {validator: validatePass2, trigger: 'blur'},
        ],
        old_password: [
          {required: true, message: '请输入旧密码', trigger: 'blur'},
          {min: 6, max: 50, message: '长度在 6 到 50 个字符', trigger: 'blur'},
        ],
        password_confirmation: [
          {required: true, message: '请重复输入新密码', trigger: 'blur'},
          {min: 6, max: 50, message: '长度在 6 到 50 个字符', trigger: 'blur'},
          {validator: validatePass, trigger: 'blur'},
        ]
      },
      form: {
        old_password: '',
        password: '',
        password_confirmation: ''
      }
    }
  },

  created () {
  },

  methods: {
    reset () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          axios.post('/settings/password', this.form).then(res => {
            this.loading = false
            if (res.data.code === 0) {
              this.$refs.form.resetFields()
              this.$message.success('修改成功');
            } else {
              this.$message.error(res.data.message);

            }
          }).catch(err => {
            this.loading = false
          })
        }
      })

    }
  }
}
</script>
